import { makeAutoObservable, runInAction } from 'mobx'
import apiClient from '../utils/apiClient'
import logger from '../utils/logger'

class GlassTypeStore {
  // Типы стекла партнера (без цен - только названия)
  glassTypes = []
  partnership = null
  
  // Состояния загрузки
  isLoading = false
  error = null

  constructor() {
    makeAutoObservable(this)
  }

  // Получение типов стекла партнера
  async fetchPartnerGlassTypes() {
    runInAction(() => {
      this.isLoading = true
      this.error = null
    })

    try {
      const response = await apiClient.get('/partnerships/partner-glass-types')
      
      runInAction(() => {
        this.glassTypes = response.data.glassTypes
        this.partnership = response.data.partnership
        this.isLoading = false
      })

      logger.log('Типы стекла партнера загружены:', response.data.count, '(без цен)')
      return response.data

    } catch (error) {
      runInAction(() => {
        this.error = error.response?.data?.error || 'Ошибка при загрузке типов стекла'
        this.isLoading = false
        this.glassTypes = []
        this.partnership = null
      })

      logger.error('Ошибка при загрузке типов стекла партнера:', error)
      throw error
    }
  }

  // Получить тип стекла по ID
  getGlassTypeById(glassTypeId) {
    return this.glassTypes.find(glassType => glassType.id === glassTypeId)
  }

  // Очистка ошибок
  clearError() {
    runInAction(() => {
      this.error = null
    })
  }

  // Сброс состояния
  reset() {
    runInAction(() => {
      this.glassTypes = []
      this.partnership = null
      this.isLoading = false
      this.error = null
    })
  }

  // Геттеры
  get hasGlassTypes() {
    return this.glassTypes.length > 0
  }

  get partnerName() {
    return this.partnership?.manufacturer_name || null
  }
}

const glassTypeStore = new GlassTypeStore()
export default glassTypeStore 